import React, { useState } from 'react';
import { PageHero } from '../components/PageHero';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ImageIcon } from 'lucide-react';
export function GalleryPage() {
  useScrollReveal();
  const [activeFilter, setActiveFilter] = useState('All');
  const categories = ['All', 'Staging', 'Audio', 'Lighting', 'Visuals', 'Corporate Events', 'Outdoor Events', 'Installations'];
  // Mock data for gallery
  const projects = Array.from({
    length: 12
  }).map((_, i) => {
    const cats = ['Staging', 'Audio', 'Lighting', 'Visuals', 'Corporate Events', 'Outdoor Events', 'Installations'];
    // Assign 1-2 random categories to each project
    const projectCats = [cats[i % cats.length], cats[(i + 3) % cats.length]];
    return {
      id: i,
      title: `Project Showcase ${i + 1}`,
      categories: projectCats,
      height: i % 3 === 0 ? 'aspect-[4/5]' : i % 4 === 0 ? 'aspect-[3/2]' : 'aspect-square'
    };
  });
  const filteredProjects = activeFilter === 'All' ? projects : projects.filter(p => p.categories.includes(activeFilter));
  return <main className="w-full" data-id="element-251">
      <PageHero title="Our Work" subtitle="Explore selected projects, event setups, and technical environments delivered by AUDIOTECH." icon={ImageIcon} data-id="element-252" />

      <section className="py-12 px-6 bg-brand-black min-h-screen" data-id="element-253">
        <div className="max-w-7xl mx-auto" data-id="element-254">
          {/* Filters */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-16 reveal" data-id="element-255">
            {categories.map(category => <button key={category} onClick={() => setActiveFilter(category)} className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${activeFilter === category ? 'bg-brand-blue text-white shadow-glow' : 'bg-brand-charcoal text-brand-muted hover:text-white hover:bg-brand-slate border border-white/5'}`} data-id="element-256">
                {category}
              </button>)}
          </div>

          {/* Masonry Grid */}
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-257">
            {filteredProjects.map((project, index) => <div key={project.id} className={`img-placeholder w-full break-inside-avoid group reveal ${project.height}`} style={{
            transitionDelay: `${index % 6 * 100}ms`
          }} data-id="element-258">
                <div className="absolute inset-0 bg-gradient-to-t from-brand-black/90 via-brand-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300 z-10" data-id="element-259" />
                <ImageIcon className="w-12 h-12 text-white/10" data-id="element-260" />

                <div className="absolute bottom-0 left-0 w-full p-6 z-20 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300" data-id="element-261">
                  <h3 className="text-white font-bold text-xl mb-2" data-id="element-262">
                    {project.title}
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-263">
                    {project.categories.map((cat, i) => <span key={i} className="text-xs font-medium px-2 py-1 rounded bg-brand-blue/20 text-brand-cyan border border-brand-blue/30" data-id="element-264">
                        {cat}
                      </span>)}
                  </div>
                </div>
              </div>)}
          </div>

          {filteredProjects.length === 0 && <div className="text-center py-20" data-id="element-265">
              <p className="text-brand-muted text-lg" data-id="element-266">
                No projects found for this category.
              </p>
            </div>}
        </div>
      </section>
    </main>;
}